export interface DiscoveryState {
  showSearchResults: boolean;
}

// Action types
export const DISCOVERY_STATE_ACTIONS = {
  SET_SHOW_SEARCH_RESULTS: 'discovery/setSearchResults',
} as const;

export interface SetShowSearchResults {
  type: typeof DISCOVERY_STATE_ACTIONS.SET_SHOW_SEARCH_RESULTS;
  payload: boolean;
}

export type DiscoveryStateActions = SetShowSearchResults;
